import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeColorVariable, ThemeFontSizeVariable, ThemeFontVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { Heading as ChakraHeading, } from '@chakra-ui/react';
/**
 * Heading is used to render semantic HTML heading elements.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/heading
 */
export function Heading({ color = ThemeColorVariable.OnBackground, fontSize = ThemeFontSizeVariable.XLarge, fontWeight = 'bold', children, fontFamily = ThemeFontVariable.Header, ...props }) {
    return (_jsx(ChakraHeading, { color: color, fontSize: fontSize, fontFamily: fontFamily, fontWeight: fontWeight, role: "heading", ...props, children: children }));
}
//# sourceMappingURL=heading.js.map